// Avisos curtos no canto da tela ("salvo", "não deu"): o showNotif do legado.
// Estado de cliente (zustand) pra qualquer feature avisar sem passar props;
// a casca desenha a pilha uma vez só.
import { create } from 'zustand';
import estilos from './avisos.module.css';

export type TipoDeAviso = 'ok' | 'erro' | 'neutro';
export interface Aviso { id: number; texto: string; tipo: TipoDeAviso }

interface EstadoDosAvisos {
  avisos: Aviso[];
  avisar(texto: string, tipo?: TipoDeAviso): void;
  fechar(id: number): void;
}

const DURACAO_MS = 4000;
let proximo = 1;

export const useAvisos = create<EstadoDosAvisos>((set) => ({
  avisos: [],
  avisar(texto, tipo = 'ok') {
    const id = proximo++;
    set((s) => ({ avisos: [...s.avisos, { id, texto, tipo }] }));
    setTimeout(() => set((s) => ({ avisos: s.avisos.filter((a) => a.id !== id) })), DURACAO_MS);
  },
  fechar(id) { set((s) => ({ avisos: s.avisos.filter((a) => a.id !== id) })); },
}));

export const avisar = (texto: string, tipo: TipoDeAviso = 'ok') => useAvisos.getState().avisar(texto, tipo);

export function Avisos() {
  const avisos = useAvisos((s) => s.avisos);
  const fechar = useAvisos((s) => s.fechar);
  if (!avisos.length) return null;
  return (
    <div className={estilos.pilha} role="status" aria-live="polite">
      {avisos.map((a) => (
        <button key={a.id} type="button" className={`${estilos.aviso} ${estilos[a.tipo]}`} onClick={() => fechar(a.id)}>{a.texto}</button>
      ))}
    </div>
  );
}
